import _ from "lodash";

export default {
  data: () => ({
    currencyRatio: null,
    priceEur: undefined,
    priceEurM: undefined,
    pricePLNM: undefined,
    isPricePLNMChanged: false,
    isPricePLNChanged: false,
  }),
  // computed: {
  //   pricePLNM: {
  //     get() {
  //       if (this.flatProperties.pow_dzialki.value) {
  //         return (
  //           this.flatProperties.cena_zakupu.value /
  //           this.flatProperties.pow_dzialki.value /
  //           10000
  //         );
  //       }
  //     },
  //     set(nV) {
  //       if (this.flatProperties.pow_dzialki.value) {
  //         console.log(nV);
  //         console.log('c');
  //         this.flatProperties.cena_zakupu.value = nV * this.flatProperties.pow_dzialki.value * 10000;
  //       }
  //     }
  //   }
  // },
  watch: {
    "flatProperties.cena_zakupu.value"() {
      this.isPricePLNChanged = true;
      this.recalculatePrices();
    },
    "flatProperties.pow_dzialki.value"() {
      this.recalculatePrices();
    },
    pricePLNM(nV) {
      this.isPricePLNMChanged = true;
      if (!this.isPricePLNChanged) {
          this.flatProperties.cena_zakupu.value = this.getFixedValue(nV * this.flatProperties.pow_dzialki.value * 10000);
      } else {
        this.isPricePLNChanged = false;
      }
    }
  },
  methods: {
    getFixedValue(value, precision = 2) {
      if (typeof value === "number") {
        return Number(Number(value).toFixed(precision));
      }
      return 0.0;
    },
    getEuroValues(value) {
      return this.getFixedValue(
        Math.round((value / this.currencyRatio + Number.EPSILON) * 100000) /
          100000
      );
    },
    async recalculatePrices() {
      try {
        if (!this.currencyRatio) {
          const response = await this.$store.dispatch("getCurrencyPrice", {
            currency: "EUR"
          });
          this.currencyRatio = response.data.rates[0].mid;
        }
        this.priceEur = this.getEuroValues(
          this.flatProperties.cena_zakupu.value
        );
        if(this.flatProperties.pow_dzialki.value && !this.isPricePLNMChanged) {
          this.pricePLNM = this.getFixedValue(this.flatProperties.cena_zakupu.value / this.flatProperties.pow_dzialki.value / 10000);
        } else {
          this.isPricePLNMChanged = false;
        }
        this.priceEurM = this.getEuroValues(this.pricePLNM);
      } catch (e) {
        this.$root.$emit("showSnackbar", e);
      }
    }
  }
};
